import { useQuery } from "react-query";

const useApplicationList = ({ getList, fetchData }) => {
	const listName = getList.name;
	const {page, filters, sortBy} = fetchData;
	const queryResult = useQuery(
		["applicationList", { listName, page, filters, sortBy }],
		() =>
			getList({
				page,
				filters,
				sortBy,
			}),
		{ retry: 0 },
	);

	return queryResult;
};

export default useApplicationList;
